import { Model, Creator, Provider, ProviderSummary, SupportedProtocol, UptimeDataPoint } from "@/types/model";

// Mock 创造者数据
export const mockCreators: Creator[] = [
  {
    id: "openai",
    name: "OpenAI",
    logo: "https://placehold.co/48x48/10a37f/fff?text=O",
    website: "https://openai.com",
    description: "Leading AI research company",
  },
  {
    id: "anthropic",
    name: "Anthropic",
    logo: "https://placehold.co/48x48/d97706/fff?text=A",
    website: "https://anthropic.com",
    description: "AI safety and research company",
  },
  {
    id: "deepseek",
    name: "DeepSeek",
    logo: "https://placehold.co/48x48/3b82f6/fff?text=D",
    website: "https://deepseek.com",
    description: "Advanced reasoning models",
  },
  {
    id: "alibaba",
    name: "Alibaba Cloud",
    logo: "https://placehold.co/48x48/ff6a00/fff?text=Q",
    website: "https://qwenlm.github.io",
    description: "Qwen model series",
  },
  {
    id: "google",
    name: "Google",
    logo: "https://placehold.co/48x48/4285f4/fff?text=G",
    website: "https://google.com",
    description: "Gemini model series",
  },
];

// Mock 供应商摘要（用于供应商详情页头部）
export const mockProviderSummaries: ProviderSummary[] = [
  { id: "openai-official", name: "OpenAI Official", logo: "https://placehold.co/32x32/10a37f/fff?text=O", region: "US-East", description: "Official OpenAI API and enterprise deployment partner." },
  { id: "azure", name: "Azure OpenAI", logo: "https://placehold.co/32x32/0078d4/fff?text=Az", region: "US-West", description: "Azure-hosted OpenAI models with enterprise compliance." },
  { id: "aws", name: "AWS Bedrock", logo: "https://placehold.co/32x32/ff9900/fff?text=AWS", region: "US-East", description: "Amazon Bedrock foundation model API platform." },
  { id: "alibaba", name: "Alibaba Cloud", logo: "https://placehold.co/32x32/ff6a00/fff?text=Ali", region: "CN-Shanghai", description: "Alibaba Cloud AI services and model hosting." },
  { id: "google", name: "Google Cloud", logo: "https://placehold.co/32x32/4285f4/fff?text=G", region: "US-West", description: "Google Cloud Vertex AI and Gemini APIs." },
  { id: "microsoft", name: "Microsoft Azure", logo: "https://placehold.co/32x32/0078d4/fff?text=MS", region: "US-East", description: "Microsoft Azure AI and OpenAI services." },
  { id: "nvidia", name: "NVIDIA", logo: "https://placehold.co/32x32/0078d4/fff?text=NV", region: "US-West", description: "NVIDIA NIM and inference platform." },
  { id: "meta", name: "Meta", logo: "https://placehold.co/32x32/0078d4/fff?text=Meta", region: "US-East", description: "Meta AI and Llama model APIs." },
  { id: "huggingface", name: "Hugging Face", logo: "https://placehold.co/32x32/0078d4/fff?text=HF", region: "US-West", description: "Hugging Face Inference API and model hub." },
  { id: "cohere", name: "Cohere", logo: "https://placehold.co/32x32/0078d4/fff?text=Co", region: "US-East", description: "Cohere language model API and embeddings." },
  { id: "mistral", name: "Mistral", logo: "https://placehold.co/32x32/0078d4/fff?text=Mi", region: "US-West", description: "Mistral AI models and inference." },
  { id: "y", name: "Yi", logo: "https://placehold.co/32x32/0078d4/fff?text=Yi", region: "US-East", description: "01.AI Yi model series API." },
];

// Mock 供应商数据生成函数
const createProviders = (modelName: string): Provider[] => {
  const baseProviders = [
    {
      id: "openai-official",
      name: "OpenAI Official",
      logo: "https://placehold.co/32x32/10a37f/fff?text=O",
      region: "US-East",
    },
    {
      id: "azure",
      name: "Azure OpenAI",
      logo: "https://placehold.co/32x32/0078d4/fff?text=Az",
      region: "US-West",
    },
    {
      id: "aws",
      name: "AWS Bedrock",
      logo: "https://placehold.co/32x32/ff9900/fff?text=AWS",
      region: "US-East",
    },
    {
      id: "alibaba",
      name: "Alibaba Cloud",
      logo: "https://placehold.co/32x32/ff6a00/fff?text=Ali",
      region: "CN-Shanghai",
    },
    {
      id: "google",
      name: "Google Cloud",
      logo: "https://placehold.co/32x32/4285f4/fff?text=G",
      region: "US-West",
    },
    {
      id: "microsoft",
      name: "Microsoft Azure",
      logo: "https://placehold.co/32x32/0078d4/fff?text=MS",
      region: "US-East",
    },
    {
      id: "nvidia",
      name: "NVIDIA",
      logo: "https://placehold.co/32x32/0078d4/fff?text=NV",
      region: "US-West",
    },
    {
      id: "meta",
      name: "Meta",
      logo: "https://placehold.co/32x32/0078d4/fff?text=Meta",
      region: "US-East",
    },
    {
      id: "huggingface",
      name: "Hugging Face",
      logo: "https://placehold.co/32x32/0078d4/fff?text=HF",
      region: "US-West",
    },
    {
      id: "cohere",
      name: "Cohere",
      logo: "https://placehold.co/32x32/0078d4/fff?text=Co",
      region: "US-East",
    },
    {
      id: "mistral",
      name: "Mistral",
      logo: "https://placehold.co/32x32/0078d4/fff?text=Mi",
      region: "US-West",
    },
    {
      id: "y",
      name: "Yi",
      logo: "https://placehold.co/32x32/0078d4/fff?text=Yi",
      region: "US-East",
    },
  ];

  return baseProviders
    .slice(0, Math.floor(Math.random() * 3) + 10)
    .map((base, idx) => ({
      ...base,
      id: `${base.id}-${modelName}`,
      latency: 500 + Math.random() * 1500,
      throughput: 10 + Math.random() * 50,
      uptime: 95 + Math.random() * 4.9,
      uptimeHistory: generateUptimeHistory(),
      pricing: {
        input: 0.1 + Math.random() * 5,
        output: 0.3 + Math.random() * 15,
      },
      features: ["ZDR Support", "Global Acceleration", "24/7 Support"].slice(
        0,
        Math.floor(Math.random() * 3) + 1,
      ),
      contextLength: [4, 32, 128, 256][Math.floor(Math.random() * 4)],
      supportedParameters: [
        "temperature",
        "top_p",
        "max_tokens",
        "tools",
        "response_format",
      ].slice(0, Math.floor(Math.random() * 5) + 3),
      supportedProtocols: (
        [
          "completions",
          "response",
          "messages",
          "completions_compatible",
          "response_compatible",
          "systemone",
        ] as SupportedProtocol[]
      ).slice(0, Math.floor(Math.random() * 2) + 2),
    }));
};

// 生成可用性历史数据（success_pct 在 [0,1]）
const generateUptimeHistory = (): UptimeDataPoint[] => {
  const history: UptimeDataPoint[] = [];
  const now = Date.now();
  for (let i = 0; i < 168; i++) {
    const pct = Math.random() > 0.05 ? 0.99 + Math.random() * 0.01 : 0.95 + Math.random() * 0.04;
    history.push({
      timestamp: now - (168 - i) * 3600000,
      success_pct: Math.min(1, pct),
    });
  }
  return history;
};

// Mock 模型数据
export const mockModels: Model[] = [
  {
    id: "deepseek-chat-v3.1",
    name: "DeepSeek V3.1",
    callName: "deepseek/deepseek-chat-v3.1",
    creator: mockCreators[2],
    description:
      "A large hybrid reasoning model (671B parameters, 37B active) that supports both thinking and non-thinking modes via prompt templates.",
    inputModalities: ["text", "image"],
    outputModalities: ["text"],
    contextLength: 128,
    releasedAt: "2026-01-15T00:00:00Z",
    reasoning: "toggleable",
    distillable: true,
    zdr: true,
    categories: [
      "Programming",
      "Reasoning",
      "General",
      "Multimodal",
      "Chinese",
      "Fast",
      "Cost-Effective",
      "Conversation",
    ],
    series: "DeepSeek",
    supportedParameters: [
      "temperature",
      "top_p",
      "max_tokens",
      "tools",
      "response_format",
      "reasoning_effort",
    ],
    providers: [],
    pricing: {
      input: "¥0 / 1M tokens",
      output: "¥0 / 1M tokens",
      cacheWrite: "",
      cacheRead: "",
    },
    performance: { avgLatency: 0, avgThroughput: 0, avgUptime: 0 },
  },
  {
    id: "gpt-4o",
    name: "GPT-4o",
    callName: "openai/gpt-4o",
    creator: mockCreators[0],
    description:
      "OpenAI's most advanced multimodal model with excellent performance across text, vision, and audio tasks.",
    inputModalities: ["text", "image", "audio"],
    outputModalities: ["text", "audio"],
    contextLength: 128,
    releasedAt: "2025-11-20T00:00:00Z",
    reasoning: "none",
    distillable: false,
    zdr: false,
    categories: ["General", "Multimodal", "Conversation"],
    series: "GPT",
    supportedParameters: [
      "temperature",
      "top_p",
      "max_tokens",
      "tools",
      "response_format",
      "frequency_penalty",
      "presence_penalty",
    ],
    providers: [],
    pricing: {
      input: "¥0 / 1M tokens",
      output: "¥0 / 1M tokens",
      cacheWrite: "",
      cacheRead: "",
    },
    performance: { avgLatency: 0, avgThroughput: 0, avgUptime: 0 },
  },
  {
    id: "claude-3.7-sonnet",
    name: "Claude 3.7 Sonnet",
    callName: "anthropic/claude-3.7-sonnet",
    creator: mockCreators[1],
    description:
      "Anthropic's balanced model offering excellent reasoning, coding, and long context capabilities.",
    inputModalities: ["text", "image"],
    outputModalities: ["text"],
    contextLength: 256,
    releasedAt: "2026-01-10T00:00:00Z",
    reasoning: "none",
    distillable: false,
    zdr: true,
    categories: ["Programming", "Writing", "Analysis"],
    series: "Claude",
    supportedParameters: ["temperature", "top_p", "max_tokens", "tools"],
    providers: [],
    pricing: {
      input: "¥0 / 1M tokens",
      output: "¥0 / 1M tokens",
      cacheWrite: "",
      cacheRead: "",
    },
    performance: { avgLatency: 0, avgThroughput: 0, avgUptime: 0 },
  },
  {
    id: "qwen-max",
    name: "Qwen Max",
    callName: "alibaba/qwen-max",
    creator: mockCreators[3],
    description:
      "Alibaba Cloud's flagship model with strong Chinese language understanding and reasoning capabilities.",
    inputModalities: ["text", "image"],
    outputModalities: ["text"],
    contextLength: 64,
    releasedAt: "2025-12-01T00:00:00Z",
    reasoning: "none",
    distillable: true,
    zdr: true,
    categories: ["General", "Chinese", "Programming"],
    series: "Qwen",
    supportedParameters: [
      "temperature",
      "top_p",
      "max_tokens",
      "tools",
      "seed",
    ],
    providers: [],
    pricing: {
      input: "¥0 / 1M tokens",
      output: "¥0 / 1M tokens",
      cacheWrite: "",
      cacheRead: "",
    },
    performance: { avgLatency: 0, avgThroughput: 0, avgUptime: 0 },
  },
  {
    id: "gemini-2.0-flash",
    name: "Gemini 2.0 Flash",
    callName: "google/gemini-2.0-flash",
    creator: mockCreators[4],
    description:
      "Google's fast and efficient multimodal model optimized for speed and cost.",
    inputModalities: ["text", "image", "video", "audio"],
    outputModalities: ["text", "image"],
    contextLength: 1024,
    releasedAt: "2025-12-15T00:00:00Z",
    reasoning: "none",
    distillable: false,
    zdr: false,
    categories: ["Multimodal", "General", "Fast"],
    series: "Gemini",
    supportedParameters: [
      "temperature",
      "top_p",
      "max_tokens",
      "tools",
      "response_format",
    ],
    providers: [],
    pricing: {
      input: "¥0 / 1M tokens",
      output: "¥0 / 1M tokens",
      cacheWrite: "",
      cacheRead: "",
    },
    performance: { avgLatency: 0, avgThroughput: 0, avgUptime: 0 },
  },
  {
    id: "gpt-4o-mini",
    name: "GPT-4o Mini",
    callName: "openai/gpt-4o-mini",
    creator: mockCreators[0],
    description:
      "Cost-effective version of GPT-4o with impressive performance for most tasks.",
    inputModalities: ["text", "image"],
    outputModalities: ["text"],
    contextLength: 128,
    releasedAt: "2025-10-01T00:00:00Z",
    reasoning: "none",
    distillable: true,
    zdr: false,
    categories: ["General", "Cost-Effective"],
    series: "GPT",
    supportedParameters: [
      "temperature",
      "top_p",
      "max_tokens",
      "tools",
      "response_format",
    ],
    providers: [],
    pricing: {
      input: "¥0 / 1M tokens",
      output: "¥0 / 1M tokens",
      cacheWrite: "",
      cacheRead: "",
    },
    performance: { avgLatency: 0, avgThroughput: 0, avgUptime: 0 },
  },
];

// 仅为详情页 mock 挂载供应商列表（模型广场/作者/供应商列表已用真实接口，不依赖此处）
mockModels.forEach((model) => {
  model.providers = createProviders(model.id);
});

// 筛选选项数据
export const filterOptions = {
  inputModalities: ["text", "image", "file", "audio", "video"] as const,
  outputModalities: ["text", "image", "audio", "video", "embeddings"] as const,
  contextLengthSteps: [4, 32, 64, 128, 256, 512, 1024] as const,
  pricingSteps: [0, 0.5, 1, 5, 10] as const,
  series: [
    "GPT",
    "Claude",
    "Qwen",
    "DeepSeek",
    "Gemini",
    "Llama",
    "Mistral",
    "Yi",
  ] as const,
  categories: [
    "Programming",
    "Roleplay",
    "Marketing",
    "Translation",
    "Writing",
    "Analysis",
    "General",
    "Reasoning",
    "Multimodal",
    "Chinese",
    "Fast",
    "Cost-Effective",
    "Conversation",
  ] as const,
  parameters: [
    "temperature",
    "top_p",
    "max_tokens",
    "tools",
    "response_format",
    "frequency_penalty",
    "presence_penalty",
    "seed",
    "reasoning_effort",
    "stop",
    "stream",
  ] as const,
  supportedProtocols: [
    "completions",
    "response",
    "messages",
    "completions_compatible",
    "response_compatible",
    "messages_compatible",
    "systemone",
  ] as const,
  providers: [
    "OpenAI",
    "Anthropic",
    "Google",
    "Alibaba Cloud",
    "Azure",
    "AWS",
    "DeepSeek",
  ] as const,
};
